const REACT_APP_API_URL = {
  // production: {
  //   mainBaseUrl: "https://fintrack-java-api.kotaholdings.in/business/fintrack",
  //   hrmsBaseUrl: "https://fintrack-java-api.kotaholdings.in/hrms/fintrack",
  //   AccountUrl: "https://accounts-production.kotaholdings.in/Api/AccountsMaster",
  //   AccountsEntry: "https://accounts-production.kotaholdings.in/Api/AccountsEntry",
  //   AccountsReports: "https://accounts-production.kotaholdings.in/Api/AccountReports",
  // },
  stage: {
    // mainBaseUrl: "https://fintrack-java-api-stage.kotaholdings.in/business/fintrack",
    hrmsBaseUrl: "https://hrms-api.sconexsoft.com/hrms/SconexSoft",
    // AccountUrl: "https://accounts-stage.kotaholdings.in/Api/AccountsMaster",
    // AccountsEntry: "https://accounts-stage.kotaholdings.in/Api/AccountsEntry",
    // AccountsReports: "https://accounts-stage.kotaholdings.in/Api/AccountReports",
  },
  // local: {
  //   mainBaseUrl: "http://localhost:9091/fintrack",
  //   // hrmsBaseUrl: "http://localhost:8091/fintrack",
  //   // hrmsBaseUrl: "https://fintrack-java-api-stage.kotaholdings.in/hrms/fintrack",
  //   hrmsBaseUrl: "https://fintrack-java-api.kotaholdings.in/hrms/fintrack",
  //   AccountUrl: "http://localhost:8091/Api/AccountsMaster",
  //   AccountsEntry: "http://localhost:8091/Api/AccountsEntry",
  //   AccountsReports: "http://localhost:8091/Api/AccountReports",
  // },
};
const { mainBaseUrl, hrmsBaseUrl, AccountUrl, AccountsEntry, AccountsReports } =
  REACT_APP_API_URL.stage; // Change this to 'stage' or 'local' as needed

export const getPresignedUrl = ({ fileName, group = "mis", env = "stage", type = "upload" }) => {
  const baseUrls = {
    stage: "https://s3service.sconexsoft.com",
    production: "https://s3service.sconexsoft.com",
  };

  const bucketNames = {
    mis: {
      stage: "fintrackmisstage",
      production: "fintrackmisprod",
    },
    disbursement: {
      stage: "fintrackdisbursementstage",
      production: "fintrackdisbursementprod",
    },
  };

  const baseUrl = baseUrls[env];
  const bucketName = bucketNames[group]?.[env];

  if (!bucketName || !baseUrl) {
    throw new Error("Invalid group or environment");
  }

  return `${baseUrl}/s3bucket/presigned-url?fileName=${encodeURIComponent(
    fileName
  )}&bucketName=${bucketName}&operation=${type}`;
};

const URLs = {
  getalldatabyroleid: `${hrmsBaseUrl}/getalldatabyroleid`,
  insuranceAgents: `${hrmsBaseUrl}/employees`,
  assignedRoleDetails: `${hrmsBaseUrl}/assignedRoleDetails`,
  assignedRoleDetailsBy: `${hrmsBaseUrl}/assignedRoleDetailsBy`,
  getemplyeenamesby: `${hrmsBaseUrl}/getemplyeenamesby`,
  hrmsGetlogsby: `${hrmsBaseUrl}/getlogsby`,

  userManuByModuleId: `${hrmsBaseUrl}/GetMenuAccessDetails`,
  newPostConfirmPayRoll: `${hrmsBaseUrl}/EmpconfromPayroll`,
  newPostRunPayRoll: `${hrmsBaseUrl}/runEmployeePayroll`,
  newGetconfirmPayRoll: `${hrmsBaseUrl}/confromEmpPayroll`,
  getPhoto: `${hrmsBaseUrl}/getphoto`,
  hrmsGetAllApplicantsBy: `${hrmsBaseUrl}/getallapplicantsby`,
  newGetRunPayRoll: `${hrmsBaseUrl}/getEmployeePayroll`,
  offerLetter: `${hrmsBaseUrl}/pdfGenerator/offer-letter`,
  deleteAdvance: `${hrmsBaseUrl}/deleteAdvanceDetails`,
  grantAdvance: `${hrmsBaseUrl}/grantAdvance`,
  updateAdvanceDetails: `${hrmsBaseUrl}/updateAdvanceDetails`,
  approveOrRejectdvance: `${hrmsBaseUrl}/approveAdvance-or-reject`,
  getAllAdvanceDetails: `${hrmsBaseUrl}/advanceDetails`,
  getEmployeeAdvanceDetails: `${hrmsBaseUrl}/employee`,
  updateAproveLeave: `${hrmsBaseUrl}/update-approval-status`,
  empLeaveDetailsAll: `${hrmsBaseUrl}/empLeavesDetails`,
  deleteEmpLeaves: `${hrmsBaseUrl}/deleteEmpLeavesBy`,
  insertLeaves: `${hrmsBaseUrl}/insertempLeavesDetails`,
  empUpdatesLeaves: `${hrmsBaseUrl}/updateEmpLeavesBy`,
  empLeaveDetails: `${hrmsBaseUrl}/empLeavesDetailsBy`,
  hrmsSendLeaveEmailUrl: `${hrmsBaseUrl}/send-leave-email`,
  connectorPaymentConfirmation: `${mainBaseUrl}/connectors/status`,
  updateMenuDetails: `${hrmsBaseUrl}/UpdateMenuDetails`,
  menuDetailsByRoleId: `${hrmsBaseUrl}/menuDetailsBy`,
  hrmsRoleDetails: `${hrmsBaseUrl}/roleDetails`,
  connectorPaymentEligibleEntries: `${mainBaseUrl}/connectorsPaymentDetails`,
  advanceConfirmation: `${mainBaseUrl}/addAdvance`,
  spotPaymentsEligibleEntries: `${mainBaseUrl}/spotPaymentDetails`,
  hrmsConfirmPayRoll: `${hrmsBaseUrl}/confromPayroll`,
  hrmsRunPayRoll: `${hrmsBaseUrl}/runPayroll`,
  hrmsPayRollIdUrl: `${hrmsBaseUrl}/payRollDetails`,
  hrmsEmployeesByCompanyId: `${hrmsBaseUrl}/employees`,
  hrmsDsaLoginDetailsUrl: `${hrmsBaseUrl}/dsaDetails`,
  hrmsLoginUrl: `${hrmsBaseUrl}/login`,
  hrmsDeletePayrollUrl: `${hrmsBaseUrl}/deleteEmployeeAddPayroll`,
  hrmsUpdatePayRollUrl: `${hrmsBaseUrl}/update/employeeAddPayroll`,
  getEmpPayRollData: `${hrmsBaseUrl}/employeeAddPayrollDetails`,
  hrmsPaymapStructs: `${hrmsBaseUrl}/update/empMapPayStructures`,
  hrmsPayrollAddedEmployees: `${hrmsBaseUrl}/by-company/empPayrollDetails`,
  hrmsBankDetailsUrl: `${hrmsBaseUrl}/bankDetails`,
  hrmsEmpLeaveUrl: `${hrmsBaseUrl}/leaveMasterDetails`,
  hrmsTimeTrackerUrl: `${hrmsBaseUrl}/dailytracker`,
  hrmsGetPayStructuresUrl: `${hrmsBaseUrl}/empMapPayStructures`,
  hrmsPayStructsByCid: `${hrmsBaseUrl}/pay-structures`,
  hrmsPostUrl: `${hrmsBaseUrl}/process`,
  hrmsGetPayRoll: `${hrmsBaseUrl}/getPayroll`,
  hrmsAddEmpToPayStruct: `${hrmsBaseUrl}/insertEmpMapPayStructures`,
  hrmsPayStructDetails: `${hrmsBaseUrl}/insertPaystructDetails`,
  hrmsCompanyDetails: `${hrmsBaseUrl}/companyDetails`,
  hrmsGetAllPayStructures: `${hrmsBaseUrl}/pay-structures`,
  hrmsPayStructure: `${hrmsBaseUrl}/pay-structure`,
  hrmsEmployeeMasterUrl: `${hrmsBaseUrl}/employeeDetails`,
  deleteAddEmppayroll: `${hrmsBaseUrl}/deleteAddEmppayroll`,
  hrmsEmployeePayrollUrl: `${hrmsBaseUrl}/employeePayrollDetails`,
  hrmsCompanyPayrollStatusUrl: `${hrmsBaseUrl}/by-company-payRollstatus`,
  hrmsFetchEmploeeLeaveTypeUrl: `${hrmsBaseUrl}/leaveMasterDetails`,
  hrmsInsertEmployeeLeaveUrl: `${hrmsBaseUrl}/insertempLeavesDetails`,
  hrmsPostAttendanceUrl: `${hrmsBaseUrl}/attendanceDetails`,
  hrmscompanyDetailsUrl: `${hrmsBaseUrl}/companyDetails`,
  hrmsCompanyCalanderDetailsUrl: `${hrmsBaseUrl}/ComapanyCalanderDetails`,
  hrmsEmployeeDetailsUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsPostSalaryAdvanceUrl: `${hrmsBaseUrl}/advanceDetails`,
  hrmsCalendarYearsUrl: `${hrmsBaseUrl}/calendar-years`,
  hrmsAttendanceListUrl: `${hrmsBaseUrl}/employeesList`,
  hrmsLeaveBalanceUrl: `${hrmsBaseUrl}/Leavebalance`,
  hrmsAdvanceDetailsUrl: `${hrmsBaseUrl}/advancedetails`,
  hrmsUpdateLeaveUrl: `${hrmsBaseUrl}/update-approval-status`,
  hrmsDeletePayStructBy: `${hrmsBaseUrl}/deletepaystructby`,
  hrmsDeletePayStructMapping: `${hrmsBaseUrl}/deletepaystructmappingby`,
  hrmsPostPayStructMapping: `${hrmsBaseUrl}/postPaystructMapping`,
  hrmsEmployeeMasterGetUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsApproveOrRejectdvance: `${hrmsBaseUrl}/approveAdvance-or-reject`,
  hrmsExistingAdvanceUrl: `${hrmsBaseUrl}/existingAdvance`,
  hrmsEmployeeAdvanceDetailsUrl: `${hrmsBaseUrl}/employee`,
  hrmsGetNotEmployees: `${hrmsBaseUrl}/getnotemployees`,
  hrmsPostEmployeeDetailsUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsGetEmployeeDetailsUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsUpdatePassword: `${hrmsBaseUrl}/updatePassword`,
  hrmsGetAllApplicants: `${hrmsBaseUrl}/getallapplicants`,
  hrmsUpdatePayStructBy: `${hrmsBaseUrl}/updatepaystructby`,
  hrmsUpdateApplicantPayStruct: `${hrmsBaseUrl}/updateapplicantpaystructby`,
  hrmsGetPayStructById: `${hrmsBaseUrl}/getpaystructby`,
  hrmsGetPayStructDetailsById: `${hrmsBaseUrl}/getpay-structuredetailsby`,
  // calendarYearsUrl: `${hrmsBaseUrl}/calendar-years`,
  hrmsGetRoleDetails: `${hrmsBaseUrl}/roleDetails`,
  hrmsPostApplicant: `${hrmsBaseUrl}/postApplicant`,
  hrmsUpdateApplicant: `${hrmsBaseUrl}/updateby`,
  hrmsDeleteApplicant: `${hrmsBaseUrl}/deleteby`,
  hrmsGetAllApplicantsPayStructures: `${hrmsBaseUrl}/getallapplicantspaystructures`,
  hrmsGetPayPeriods: `${hrmsBaseUrl}/GetMonthNames`,
  hrmsViewPayslips: `${hrmsBaseUrl}/viewPayslipsby`,
  hrmsViewPayslipsById: `${hrmsBaseUrl}/viewPayslips`,
  hrmsPayslipPdf: `${hrmsBaseUrl}/payslipPdf`,
  hrmsRunPayroll: `${hrmsBaseUrl}/run`,
  hrmsConfirmPayroll: `${hrmsBaseUrl}/confirm`,
  hrmsPostRunPayroll: `${hrmsBaseUrl}/RunPayRoll`,
  hrmsPostConfirmPayroll: `${hrmsBaseUrl}/ConfirmPayroll`,
  hrmsGetAttendanceList: `${hrmsBaseUrl}/employeesList`,
  //teja urls hrms
  hrmsPayStructure: `${hrmsBaseUrl}/pay-structures`,
  hrmsBankDetails: `${hrmsBaseUrl}/bankDetails`,
  hrmsEmployeesLevel: `${hrmsBaseUrl}/levelDetails`,
  hrmsDepartmentUrl: `${hrmsBaseUrl}/departDetails`,
  addEmployeeToPayRoll: `${hrmsBaseUrl}/addPayroll`,
  hrmsEmployeeMasterUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsGetPhoto: `${hrmsBaseUrl}/getphoto`,
  hrmsGetEmployeedByPayRollStatus: `${hrmsBaseUrl}/by-company-payRollstatus`,
  hrmsGetEmployeedByPayRollStatus: `${hrmsBaseUrl}/by-company-payRollstatus`,
  hrmsGetOfferLetterPrint: `${hrmsBaseUrl}/offer-letterforApplicant`,

  hrmsRoleDetailsUrl: `${hrmsBaseUrl}/roleDetails`,
  hrmsEmployeeMasterUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsUpdatePassword: `${hrmsBaseUrl}/updatePassword`,
};

export default URLs;
